import React, { useState } from 'react';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import { mutateConfig } from '../../../api/queryBase';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessage } from '../../../utils/helper';
import { EditIcon } from '../../../components/icons';
import { Divider } from 'antd';
import Button from '../../../components/button/Button';
import Passwordinput from '../../../components/passwordinput/passwordinput';

interface ChangePasswordForm {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

const ChangePassword = () => {
    const [editValues, setEditValues] = useState(false);
    const mutation = mutateConfig({ method: 'patch' });
    const { user } = useSelector((state: RootState) => ({
        user: state.user.user
    }));

    const { mutate } = mutation({
        url: `/users/${user?.user_id}/password`
    });

    const formik = useFormik({
        initialValues: {
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
        },
        validationSchema: object({
            currentPassword: string().required(),
            confirmPassword: string().required(),
            newPassword: string().required()
        }),
        onSubmit: (values) => {
            formik.setSubmitting(true);
            const { confirmPassword, ...data } = values;
            mutate(data, {
                onSettled: (_, error: AxiosError | undefined | any) => {
                    formik.setSubmitting(false);
                    if (error) {
                        toast.error(
                            getErrorMessage(error) ||
                                'Profile Update failed. Please try again later'
                        );
                        return;
                    }
                    toast.info('Password Updated successfully');
                    setEditValues(false);
                }
            });
        }
    });

    return (
        <div className='flex flex-col lg:max-w-[500px] max-w-[100%] w-full mx-auto lg:mx-0 mt-8 gap-[5px]'>
            <div className='flex flex-row justify-between items-center'>
                <h3 className='color-[#1D2939] text-[16px] font-[500]'>
                    Password
                </h3>

                {!editValues && (
                    <div
                        className='flex items-center justify-center rounded-[8px] p-[12px] cursor-pointer hover:bg-gray-100'
                        onClick={() => setEditValues(!editValues)}
                    >
                        <EditIcon />
                    </div>
                )}
            </div>

            <Divider className='my-2' />

            <div className='flex-1 w-full'>
                <Passwordinput
                    label='Current Password'
                    error={
                        formik.touched?.currentPassword &&
                        !!formik.errors.currentPassword
                    }
                    name='currentPassword'
                    id='currentPassword'
                    showToggle
                    disabled={!editValues}
                    updateField={formik.handleChange}
                />
            </div>

            <div className='flex-1 w-full'>
                <Passwordinput
                    label='New Password'
                    error={
                        formik.touched?.newPassword &&
                        !!formik.errors.newPassword
                    }
                    name='newPassword'
                    id='newPassword'
                    showToggle
                    disabled={!editValues}
                    updateField={formik.handleChange}
                />
            </div>

            <div className='flex-1 w-full'>
                <Passwordinput
                    label='Confirm New Password'
                    error={
                        formik.touched?.confirmPassword &&
                        !!formik.errors.confirmPassword
                    }
                    name='confirmPassword'
                    id='confirmPassword'
                    showToggle
                    disabled={!editValues}
                    updateField={formik.handleChange}
                />
            </div>

            {editValues && (
                <div className='flex flex-row mt-[20px] mb-8 items-center gap-[15px] '>
                    <Button
                        type='button'
                        variant='secondaryOutline'
                        text='Cancel'
                        className='flex-1'
                        onClick={() => {
                            setEditValues(false);
                        }}
                    />

                    <Button
                        type='button'
                        isLoading={formik.isSubmitting}
                        text='Save new password'
                        className='flex-1'
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default ChangePassword;
